import SEO from '@/utils/SEO'
import React, { useContext, useEffect, useState } from 'react'
import DashboardLayout from '../Dashboard/DashboardLayout'
import dashboardImg from '../../assets/images/iquippo-website.svg'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import AuthContext from '@/product/context/auth/authContext'
import DashboardNavigation from '@/custom/components/molecules/DashboardNavigation'
const MerchantSectionDash = (props) => {
    const authContext = useContext(AuthContext)

    const { user, loadUser } = authContext

    return (
        <>
            <SEO title="My Invoice" url={window.location.href} />
            <DashboardLayout title={'Dashboard'}>
                <DashboardNavigation />
                <div className="dashboardInner mySavedSearches profileComponent ">
                    <div className="merchantSectionDash accountCnt">
                        <h3>Welcome to the new and refreshed website of iQuippo!</h3>
                        <div className="imageSection">
                            <img
                                className="m-5"
                                src={dashboardImg}
                                alt="Merchant Section"
                                style={{ width: '100%', height: '300px' }}
                            />

                            <p>
                                iQuippo is India&#39;s first and a one-of-its-kind digital
                                marketplace for construction equipment, machinery and services. Our
                                platform allows buyers and sellers to interact, negotiate and close
                                transactions in a timely, transparent and cost-effective manner.
                            </p>
                            <p>
                                Thank you for registering with us. Please complete your profile to
                                purchase the equipments available on our site, participate in
                                auctions or get the valuation done for your equipments.
                            </p>
                            <div className="d-flex justify-content-center">
                                {user ? (
                                    user.admin && user.user_type == 2 ? (
                                        <PrimaryButton
                                            onClick={() => {
                                                let btoaEmail = btoa(user.email)

                                                window.open(
                                                    `${process.env.REACT_APP_ADMIN_URL}/switch?user_id=${btoaEmail}`,
                                                    '_blank',
                                                )

                                                // props.history.push('/account/profile')
                                            }}
                                        >
                                            View Seller Dashboard
                                        </PrimaryButton>
                                    ) : (
                                        <PrimaryButton
                                            onClick={() => props.history.push('profile')}
                                        >
                                            {user && !user.is_kyc_done
                                                ? 'Complete KYC Details'
                                                : 'Update Profile Details'}
                                        </PrimaryButton>
                                    )
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </>
    )
}

export default MerchantSectionDash
